export default class MvMotion {
    constructor(controller) {
        this.controller = controller;
        this.init();
    }

    init() {
        this.mvMotion();
    }

    mvMotion() {
        const modalOpenTrigger = document.querySelector('.js-modal-openTrigger');
        const modalCloseTrigger = document.querySelector('.js-modal-closeTrigger');
        const modal = document.querySelector('.js-modal');

        modalOpenTrigger.addEventListener('click', () => {
            modal.classList.add('-show');
            document.body.classList.add('-lock');
        });
        modalCloseTrigger.addEventListener('click', () => {
            modal.classList.remove('-show');
            document.body.classList.remove('-lock');
        });
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.classList.remove('-show');
                document.body.classList.remove('-lock');
            }
        }
    }
}
